import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { DEFAULT_LANGUAGE } from '../services/language/language.const';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const lang = localStorage.getItem('lang') || DEFAULT_LANGUAGE;

    const modifiedRequest = request.clone({
      setHeaders: { 'x-lang': lang },
    });

    return next.handle(modifiedRequest);
  }
}
